/**
 * Constants
 */
const SET_SIZE = 'layout@SET_SIZE';
const SET_STICKY_HEADER = 'layout@SET_STICKY_HEADER';
const SET_TRAILER_VISIBLE = 'layout@SET_TRAILER_VISIBLE';
const SET_MOBILE = 'layout@SET_MOBILE';

/**
 * Actions creator
 */
const setSize = size => ({
    type: SET_SIZE,
    payload: {
        ...size,
    },
});

const setStickyHeader = sticky => ({
    type: SET_STICKY_HEADER,
    payload: sticky,
});

const setMobile = mobile => ({
    type: SET_MOBILE,
    payload: mobile,
});

const setTrailerVisible = value => ({
    type: SET_TRAILER_VISIBLE,
    payload: value,
});

/**
 * Exports
 */
export {
    SET_SIZE,
    SET_STICKY_HEADER,
    SET_TRAILER_VISIBLE,
    SET_MOBILE,
    setSize,
    setStickyHeader,
    setTrailerVisible,
    setMobile,
};



// WEBPACK FOOTER //
// ./js/actions/LayoutActions.js